// extracted by mini-css-extract-plugin
export default {"container":"container-b_jd3Z2z","text":"text-c_dIyGEs","time":"time-kKP0xxvq","lowTime":"lowTime-ijj8_4uW"};